// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import horizontalBarChart02Icon from "@/assets/icons/horizontal-bar-chart-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type HorizontalBarChart02IconProps = Omit<IconProps, "name">;

export function HorizontalBarChart02Icon(props: HorizontalBarChart02IconProps): React.ReactNode {
  return <Icon name={horizontalBarChart02Icon} {...props} />;
}
